define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi",
	"csi/def/Action",
	"csi/def/ViewRef",
	"csi/state/rootStore",
	"csi/xml",
	"csi/xml/Query",
	"Apparel/MaterialRefMixin",
	"Specification/BOM/BOMSectionMixin",
	"SiteAdmin/DataSheetItemActual"
], function(declare, lang, csi, Action, ViewRef, { routerStore }, xml, Query, MaterialRefMixin, BOMSectionMixin, DataSheetItemActual) {

	return declare([DataSheetItemActual, MaterialRefMixin, BOMSectionMixin], {
		bCopy: true,
		PART_MATERIAL: "PartMaterial",

		isForMaterialBOM: function(/*Context*/ctx) {
			// summary: determine if need to filter for Materials okay'd to appear on Material BOM
			return !!routerStore.getBreadcrumbNode("Material");
		},

		isForStyleBOM: function(/*Context*/ctx) {
			// summary: determine if need to filter for Materials okay'd to appear on Style BOM
			return (!!routerStore.getBreadcrumbNode("Style")) || (ctx.defView.m_rcRoot.m_type == "ApparelBOMRevision");
		},

		_addFilters: function(/*Context*/ctx, /*Query*/q) {
			// summary: return filters for selecting materials
			const pm = ctx.getNode();
			if (pm) {
				if (this._isSeasonAvailabilityEnforced(ctx)) {
					this._applySeasonAvailabilityFilters(q, ctx);
				}
				if (xml.isValidURL(pm.PSPlacement)) {//pm is a productStructure only apply PS rules
					var psp = ctx.cache.getNode(pm.PSPlacement);
					q.RefAttr("ProductType", xml.OP_EQUALS, psp.MaterialType);
					q.Attr("Usable", xml.OP_EQUALS, true);
				} else {
					if (!pm.ForStyle) {
						this._applyUsableFilters(q, ctx);
					}
					this.applyBomSectionQuery(pm.DSSection, q, ctx.cache);//apply BOMSection Def Limits if they exist
				}
			}
		},

		/**
		 * @override
		 * Generate unique key for aggregate store that depends on Style vs Material, Product Structure, and BOM Section
		 */
		getCustomStoreKey(ctx, h, bAll) {
			const {$URL, DSSection, ForStyle, PSPlacement} = ctx.getNode();
			const section = ctx.cache.getNode(DSSection);
			const sectionUrl = (section && !section.AdHoc) ? DSSection : csi.EMPTY_URL;
			const partMaterialUrl = xml.isValidURL(PSPlacement) ? $URL : csi.EMPTY_URL;
			return `${partMaterialUrl}^${sectionUrl}^${ForStyle}`;
		},

		_getStoreAction: function(/*Context*/ctx, /*Heading*/h, /*Boolean*/bAll) {
			// summary: apply special logic for assortments and structured placements
			let pm = ctx.getNode();
			let q = new Query();
			let viewRef = "MaterialsView";
			this._addFilters(ctx, q);
			if (pm && pm.ForStyle) {
				// select Style rather than Material
				viewRef = "AllStyles";
				q.Attr("InAssortment", xml.OP_EQUALS, true, "Child:ProductType/Child:ProductionConfig")
					.Attr("Active", xml.OP_EQUALS, true);
			}

			let action = lang.mixin(new Action(), {
				m_fixedQuery: q,
				m_viewRef: lang.mixin(new ViewRef(), {
					m_id: viewRef,
					m_url: "centric://APPAREL/Views"
				})
			});

			return action;
		},

		/**
		 * @override
		 * Add unavailable CSS if PartMaterial.CommonColorAvailable or PartMaterialColor.ColorAvailable is false
		 */
		_getRenderCSS: function(ctx, h) {
			let css = this.inherited(arguments);
			const node = ctx.getNode();
			if (!node) {
				return css;
			}

			const nodeType = ctx.getNodeType();
			if ((nodeType === this.PART_MATERIAL && node.ValidationStatus && node.ValidationStatus.length)) {
				if (node.ValidationStatus[0] != "BOMValidation:" && node.ValidationStatus[0] != "BOMValidation:Valid") {
					css += " unavailable";
				}
			}
			return css;
		}
	});
});